import { useGetLatestExamEventOverviewReportCreatedAtQuery } from '@report/graphql';
import { Link } from '@report/router';
import { ArrowBackRoundedIcon, Button, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export default function ExamEventOverviewReportPageHeader() {
  const { data } = useGetLatestExamEventOverviewReportCreatedAtQuery();

  const latestCreatedAt = formatDateTime(
    data?.reportGetLatestExamEventOverviewReportCreatedAt.latestCreatedAt,
  );

  return (
    <PageHeader
      linkAdornment={
        // TODO: replace with NavigateBackLink component in report/components package
        <Button
          variant='text'
          component={Link}
          to='/reports'
          sx={{
            p: 0,
            m: 0,
            justifyContent: 'flex-start',
            color: (theme) => theme.palette.text.secondary,
          }}
          startIcon={<ArrowBackRoundedIcon />}
        >
          Back
        </Button>
      }
      title='รายงานสรุปผลภาพรวมการสอบ'
      subtitleSection={
        <>
          <Text variant='body2' color='text.secondary'>
            สรุปจำนวนรอบสอบ ผู้สมัคร และผู้เข้าสอบ แยกตามประเภทการสอบและศูนย์สอบ
          </Text>
          <Text variant='body2' color='text.secondary'>
            อัปเดตข้อมูลล่าสุด: {latestCreatedAt}
          </Text>
        </>
      }
    />
  );
}
